//libraries
// import ReactGA from "react-ga4";
// import firebase from "../../firebase";

import "../css/Website.scss";
// import ReactPinterestTag from "react-pinterest-tag";
import StipplLogo from "../img/stippl-logo.svg";

// import Icon from "components/Icons/Icon";
import AppStoreButtons from "components/downloadappcta/appstorebuttons/AppStoreButtons";
import Icon from "components/Icons/Icon";
import { HELP_CENTRE_URL } from "constants/helpCentre";
import { t } from "i18n/index";
import { discoverPath, localizeHref } from "i18n/urlLocale";
import { useMarketingLang } from "i18n/useMarketingLang";
import { openCookieSettings } from "utils/openCookieSettings";
import { getChromeTranslations } from "../marketing/i18n/pages/chrome";
import { localizedDestinationLabel, POPULAR_DESTINATIONS } from "../pages/Home";
// import { analytics } from "components/common/analytics";

// import Twitter from "../img/twitter.png";

const Footer = ({ background = "main3" }) => {
	// const onAnonymous = async () => {
	//   ReactGA.event({
	//     category: "Anonymous",
	//     action: "created_anonymous_account",
	//     label: "Homepage header",
	//   });
	//   ReactPinterestTag.track("signup", { lead_type: "anonymous signup" });
	//   try {
	//     await firebase.loginAnonymously();
	//     analytics.track("Anonymous Login", { location: "Website Footer" });
	//   } catch (error) {
	//     alert(error);
	//   }
	// };
	const lang = useMarketingLang();
	const translations = getChromeTranslations(lang);
	return (
		<>
			<footer className={`stippl-footer ${background}`}>
				<div className="stippl-footer__inner">
					<div className="stippl-footer__content">
						<div className="stippl-footer__column stippl-footer__column--brand">
							<div className="logo">
								<img src={StipplLogo} alt="Stippl logo" />
							</div>
							<p className="stippl-footer__tagline">
								{t(translations, "footer.tagline", "Plan trips together, discover new places, and take it all offline.")}
							</p>
							<AppStoreButtons />
							<ul className="socials">
								<li>
									<a href="https://www.tiktok.com/@stippl.io" target="_blank" rel="noreferrer" aria-label="Stippl on TikTok">
										<Icon name="tiktok" />
									</a>
								</li>
								<li>
									<a href="https://www.instagram.com/stippl.io" target="_blank" rel="noreferrer" aria-label="Stippl on Instagram">
										<Icon name="instagram" />
									</a>
								</li>
								<li>
									<a href="https://www.facebook.com/stippl" target="_blank" rel="noreferrer" aria-label="Stippl on Facebook">
										<Icon name="facebook" />
									</a>
								</li>
								<li>
									<a href="https://www.linkedin.com/company/stippl" target="_blank" rel="noreferrer" aria-label="Stippl on LinkedIn">
										<Icon name="linkedin" />
									</a>
								</li>
							</ul>
						</div>
						<div className="stippl-footer__column">
							<h4>{t(translations, "nav.features", "Features")}</h4>
							<ul>
								<li>
									<a href={localizeHref("/itinerary-planner", lang)}>{t(translations, "footer.itineraryPlanner", "Itinerary planner")}</a>
								</li>
								<li>
									<a href={localizeHref("/ai-travel-planner", lang)}>{t(translations, "footer.aiPlanner", "AI Planner")}</a>
								</li>
								<li>
									<a href={localizeHref("/chatgpt-travel-planner", lang)}>{t(translations, "footer.chatgptPlanner", "ChatGPT planner")}</a>
								</li>
								<li>
									<a href={localizeHref("/claude-travel-planner", lang)}>{t(translations, "footer.claudePlanner", "Claude planner")}</a>
								</li>
								<li>
									<a href={localizeHref("/budget-planner", lang)}>{t(translations, "footer.budgetPlanner", "Budget planner")}</a>
								</li>
								<li>
									<a href={localizeHref("/packing-list", lang)}>{t(translations, "footer.packingList", "Packing list")}</a>
								</li>
								<li>
									<a href={localizeHref("/travel-tracker", lang)}>{t(translations, "footer.travelTracker", "Travel Tracker")}</a>
								</li>
								<li>
									<a href={localizeHref("/photobook", lang)}>{t(translations, "footer.travelPhotobook", "Travel Photobook")}</a>
								</li>
								<li>
									<a href={localizeHref("/esim", lang)}>{t(translations, "footer.esim", "eSIM")}</a>
								</li>
								<li>
									<a href={localizeHref("/pro", lang)}>{t(translations, "footer.stipplPro", "Stippl Pro")}</a>
								</li>
							</ul>
						</div>
						<div className="stippl-footer__column">
							<h4>{t(translations, "footer.discover", "Discover")}</h4>
							<ul>
								{POPULAR_DESTINATIONS.map(({ label, geo }) => (
									<li key={geo}>
										<a href={discoverPath(`/discover/${geo}`, lang)}>{localizedDestinationLabel({ label, geo }, lang)}</a>
									</li>
								))}
								{/* The hub above all ~170 guide pages (123yb6937h0). It is in the sitemap, but this is
								    the only internal link to it anywhere on the marketing site: the homepage's two
								    "Browse all"/"All destinations" CTAs were turned into plan-gated buttons while
								    /discover was a dead shell (see TrendingDestinationsSection.tsx), and nothing put
								    an href back. A hub with no inbound links cannot pass equity on to the guides
								    beneath it, which is the whole point of the page. */}
								<li>
									<a href={discoverPath("/discover", lang)}>{t(translations, "footer.allDestinations", "All destinations")}</a>
								</li>
							</ul>
						</div>
						<div className="stippl-footer__column">
							<h4>{t(translations, "footer.resources", "Resources")}</h4>
							<ul>
								<li>
									<a href="/about">{t(translations, "footer.aboutUs", "About us")}</a>
								</li>
								<li>
									<a target="_blank" href="/survey">
										{t(translations, "footer.giveUsFeedback", "Give feedback")}
									</a>
								</li>
								<li>
									<a href="/contact">{t(translations, "footer.contactUs", "Contact")}</a>
								</li>
								<li>
									<a id="footer-help-center" href={HELP_CENTRE_URL}>
										{t(translations, "footer.helpCenter", "Help center")}
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="footer-row">
						<p className="copyright">{t(translations, "footer.copyright", "© Copyright 2026 Stippl B.V. All rights reserved.")}</p>
						<ul className="legal-menu">
							<li>
								<a href="/terms">{t(translations, "footer.terms", "Terms & Conditions")}</a>
							</li>
							<li>
								<a href="/privacy">{t(translations, "footer.privacy", "Privacy")}</a>
							</li>
							<li>
								<a href="/disclaimer">{t(translations, "footer.disclaimer", "Disclaimer")}</a>
							</li>
							<li>
								<button type="button" onClick={openCookieSettings}>
									{t(translations, "footer.cookieSettings", "Cookie settings")}
								</button>
							</li>
						</ul>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
